import gsap from 'gsap'

import {
  fadeRevealAnimation,
  getScrollTriggerOptions,
  type SharedAnimation
} from '@/components/sections/animations/shared'

import { Animation } from '@/types'

export const quickCollectionMenuRevealAnimation = ({
  node,
  context,
  reverse,
  delay = 0
}: Animation) => {
  const selector = context?.selector || gsap.utils.selector(node)

  const images = selector('[data-motion-images]')[0]
  const items = selector('[data-motion-item]')

  const timeline = gsap.timeline({
    ...getScrollTriggerOptions(node, reverse),
    delay
  })

  let imagesAnimation: SharedAnimation
  if (images) {
    imagesAnimation = fadeRevealAnimation(images)
    timeline.add(imagesAnimation.timeline, 0)
  }

  let itemsAnimation: SharedAnimation
  if (items.length) {
    itemsAnimation = {
      timeline: gsap
        .timeline()
        .fromTo(
          items,
          { opacity: 0, y: 30 },
          {
            opacity: 1,
            y: 0,
            duration: 0.8,
            ease: 'power2.out',
            stagger: 0.1
          }
        ),
      revert: () => {
        return
      }
    }
    timeline.add(itemsAnimation.timeline, 0.2)
  }

  return () => {
    timeline.scrollTrigger?.kill()
    timeline.kill()

    imagesAnimation?.revert()
    itemsAnimation?.revert()
  }
}
